var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-card",
    {
      attrs: { hover: "" },
      nativeOn: {
        click: function ($event) {
          return _vm.showDetail()
        },
      },
    },
    [
      _c("v-card-text", [
        _c("h3", { staticClass: "headline mb-0" }, [
          _vm._v("Modello: " + _vm._s(_vm.reintegro.idModello)),
        ]),
        _c("div", { staticClass: "text-truncate" }, [
          _vm._v("STAGIONE: "),
          _c("strong", [_vm._v(_vm._s(_vm.reintegro.idStagione))]),
        ]),
        _c("div", { staticClass: "text-truncate" }, [
          _vm._v("COLORE: "),
          _c("strong", [_vm._v(_vm._s(_vm.reintegro.idColore))]),
        ]),
        _c("div", { staticClass: "text-truncate" }, [
          _vm._v("DATA INSERIMENTO: "),
          _c("strong", [
            _vm._v(
              _vm._s(_vm._f("formatDateTime")(_vm.reintegro.dataOraInserimento))
            ),
          ]),
        ]),
        _c("div", { staticClass: "text-truncate" }, [
          _vm._v("NUM. RIGHE: "),
          _c("strong", [_vm._v(_vm._s(_vm.reintegro.numRighe))]),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }